import { ref } from 'vue';

export function useDialogState() {
  // Dialog states
  const showValidateDialog = ref(false);
  const showLoginDialog = ref(false);
  const showLoginSentDialog = ref(false);
  const showLoginVerifyDialog = ref(false);
  const showWelcomeDialog = ref(false);
  const showEmailNotFoundDialog = ref(false);
  const showSignupAttemptsExceededDialog = ref(false);
  const showLoginAttemptsExceededDialog = ref(false);
  const showGenericSignupErrorDialog = ref(false);

  // Dialog handling methods
  function switchToLogin(form, loginEmailRef) {
    showValidateDialog.value = false;
    if (form && loginEmailRef) {
      loginEmailRef.value = form.email;
      form.name = '';
      form.email = '';
    }
    showLoginDialog.value = true;
  }

  function continueToAccount(router, showWelcomeDialogRef) {
    if (showWelcomeDialogRef) showWelcomeDialogRef.value = false;
    if (router) router.push('/account');
  }

  function switchToSignupFromEmailNotFound(form, loginEmailRef) {
    showEmailNotFoundDialog.value = false;
    if (form && loginEmailRef) {
      form.email = loginEmailRef.value;
      loginEmailRef.value = '';
    }
  }

  function closeEmailNotFoundDialog(showLoginDialogRef, loginEmailRef) {
    showEmailNotFoundDialog.value = false;
    if (showLoginDialogRef) showLoginDialogRef.value = true;
    if (loginEmailRef) loginEmailRef.value = '';
  }

  function restartSignupProcess(form, validationCodeRef, validationAttemptsRef, validationErrorRef) {
    showSignupAttemptsExceededDialog.value = false;
    if (form) {
      form.name = '';
      form.email = '';
    }
    if (validationCodeRef) validationCodeRef.value = '';
    if (validationAttemptsRef) validationAttemptsRef.value = 0;
    if (validationErrorRef) validationErrorRef.value = '';
  }

  function restartLoginProcess(loginVerificationCodeRef, loginAttemptsRef, loginErrorRef, showLoginDialogRef) {
    showLoginAttemptsExceededDialog.value = false;
    if (loginVerificationCodeRef) loginVerificationCodeRef.value = '';
    if (loginAttemptsRef) loginAttemptsRef.value = 0;
    if (loginErrorRef) loginErrorRef.value = '';
    if (showLoginDialogRef) showLoginDialogRef.value = true;
  }

  return {
    showValidateDialog,
    showLoginDialog,
    showLoginSentDialog,
    showLoginVerifyDialog,
    showWelcomeDialog,
    showEmailNotFoundDialog,
    showSignupAttemptsExceededDialog,
    showLoginAttemptsExceededDialog,
    showGenericSignupErrorDialog,
    switchToLogin,
    continueToAccount,
    switchToSignupFromEmailNotFound,
    closeEmailNotFoundDialog,
    restartSignupProcess,
    restartLoginProcess
  };
}
